import { setupColorModelSelect } from "./color-model-select"

function initCartBulkUpdate() {
  const colorSelect = document.querySelector(".cart-bulk-color-select")
  const modelSelect = document.querySelector(".cart-bulk-model-select")

  if (!colorSelect || !modelSelect) {
    return
  }

  const form = colorSelect.closest("form")
  const submitButton = form?.querySelector(".cart-bulk-update__submit")
  const saveModeInput = form?.querySelector("[name=save_mode]")

  const updateSubmitState = () => {
    if (!submitButton) {
      return
    }

    submitButton.disabled = colorSelect.value === "" || modelSelect.value === ""
  }

  setupColorModelSelect({
    colorSelect,
    modelSelect,
    onAnyChange: updateSubmitState,
  })

  updateSubmitState()

  form.addEventListener("submit", (e) => {
    if (form.dataset.confirmed === "true") {
      return
    }

    e.preventDefault()
    e.stopPropagation()
    openConfirmModal(form, saveModeInput)
  })
}

function openConfirmModal(form, saveModeInput) {
  const modal = document.getElementById("modal-bulk-update-confirm")

  if (!modal) {
    return
  }

  if (saveModeInput) {
    saveModeInput.value = "none"
  }

  const rebind = (selector, handler) => {
    const btn = modal.querySelector(selector)

    if (!btn) {
      return
    }

    const fresh = btn.cloneNode(true)
    btn.replaceWith(fresh)
    fresh.addEventListener("click", handler)
  }

  rebind(".bulk-update-confirm__mail", () => handleMail(form))
  rebind(".bulk-update-confirm__share", handleShare)
  rebind(".bulk-update-confirm__skip", () => handleSkip(form))

  window.showModal("modal-bulk-update-confirm")
}

function showConfirmModalLoader() {
  const dialog = document.querySelector(
    "#modal-bulk-update-confirm .modal__dialog.loader-handler",
  )

  if (dialog) {
    dialog.classList.add("loading")
  }
}

function handleSkip(form) {
  form.dataset.confirmed = "true"
  showConfirmModalLoader()
  form.requestSubmit()
}

function handleShare(event) {
  const btn =
    event?.currentTarget ||
    document.querySelector(".bulk-update-confirm__share")

  if (!btn) {
    return
  }

  const copiedMessage = btn.dataset.copiedMessage || "Link copied"
  const url = btn.dataset.shareUrl || window.location.href

  const markShared = () => {
    const saveModeInput = document.querySelector(
      ".cart-bulk-update [name=save_mode]",
    )

    if (saveModeInput) {
      saveModeInput.value = "share"
    }
  }

  if (navigator.share) {
    navigator.share({ url, title: document.title }).then(markShared, () => {})
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(
      () => {
        if (window.showInfoBubble) {
          window.showInfoBubble(copiedMessage)
        }
        markShared()
      },
      () => {},
    )
  }
}

function initCartShareButtons() {
  document.querySelectorAll(".cart-share-button").forEach((btn) => {
    if (btn.dataset.shareInitialized === "true") {
      return
    }

    btn.dataset.shareInitialized = "true"
    btn.addEventListener("click", handleShare)
  })
}

function handleMail(form) {
  window.closeModal("modal-bulk-update-confirm")

  const emailModal = document.getElementById("modal-send-and-bulk-update")
  if (!emailModal) {
    return
  }

  const colorInput = emailModal.querySelector("[name=color_id]")
  const modelInput = emailModal.querySelector("[name=model_id]")

  if (colorInput) {
    colorInput.value = form.querySelector("[name=color_id]").value
  }

  if (modelInput) {
    modelInput.value = form.querySelector("[name=model_id]").value
  }

  window.showModal("modal-send-and-bulk-update")
}

function dismissBulkSkippedModal() {
  window.closeModal("modal-bulk-update-skipped")
}

function initLineItemErrorConfirm() {
  if (window.__lineItemErrorConfirmReady) {
    return
  }

  window.__lineItemErrorConfirmReady = true

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".order-line-item__error-confirm")

    if (!btn) {
      return
    }

    btn.closest(".order-line-item")?.classList.remove("order-line-item--error")
  })
}

function scrollFirstErrorBelowModal() {
  const modal = document.querySelector(
    "#modal-bulk-update-skipped .modal__dialog",
  )
  const target = document.querySelector(".order-line-item--error")

  if (!modal || !target) {
    return
  }

  const modalRect = modal.getBoundingClientRect()
  const targetRect = target.getBoundingClientRect()
  const padding = 20
  const delta = targetRect.top - modalRect.bottom - padding

  window.scrollBy({ top: delta, behavior: "smooth" })
}

window.initCartBulkUpdate = initCartBulkUpdate
window.initCartShareButtons = initCartShareButtons
window.dismissBulkSkippedModal = dismissBulkSkippedModal
window.scrollFirstErrorBelowModal = scrollFirstErrorBelowModal
document.addEventListener("DOMContentLoaded", () => {
  initCartBulkUpdate()
  initCartShareButtons()
  initLineItemErrorConfirm()
})
